/**
 * #769 — a tiny module-level flag the chat/stream surface flips while a
 * request is in flight, so the app-shell version checker (which lives far from
 * the Data Analyst's local React state) can tell whether an auto-reload would
 * cut off a running answer.
 *
 * Deliberately not React state: the version checker reads it imperatively at
 * decision time, not on every render. A ref-count would over-engineer a
 * single-consumer signal (only one chat runs at a time), so a boolean is enough.
 */

let chatBusy = false;

/** Called by the Data Analyst while a chat request/stream is active. */
export function setChatBusy(busy: boolean): void {
  chatBusy = busy;
}

/** True while a chat request/stream is in flight. */
export function isChatBusy(): boolean {
  return chatBusy;
}
